import { useState, useCallback } from 'react';

/**
 * Manage trajectory simulator state and parameter adjustments
 * @param {Object} initialPresets - Initial preset values from API
 * @returns {Object} { simulatedParams, applyPreset, updateMetric, resetToPreset }
 */
export const useTrajectorySimulator = (initialPresets = {}) => {
  const [simulatedParams, setSimulatedParams] = useState(
    initialPresets.current || null
  );

  const applyPreset = useCallback((presetName) => {
    if (initialPresets[presetName]) {
      setSimulatedParams(initialPresets[presetName]);
    }
  }, [initialPresets]);

  const updateMetric = useCallback((metric, value) => {
    setSimulatedParams(prev => ({
      ...prev,
      [metric]: parseFloat(value)
    }));
  }, []);

  const resetToPreset = useCallback((presetName = 'current') => {
    applyPreset(presetName);
  }, [applyPreset]);

  return {
    simulatedParams,
    setSimulatedParams,
    applyPreset,
    updateMetric,
    resetToPreset
  };
};
